// extracted by mini-css-extract-plugin
module.exports = {"meta":"v_H","card":"v_g"};